import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { CommonFieldSetEdsn, HysteresisFieldSet } from 'src/Libs/wallboxes/components/settings/tiles'
import WallboxSettingsFormGridContainer from './WallboxSettingsFormGridContainer'
import WallboxSettingsFormGridItem from './WallboxSettingsFormGridItem'

interface Props {
  model: WallboxConfigurationModel
  hasWritingAccess: boolean
}

/**
 *  EDSN wallbox settings form
 */
const WallboxSettingsEdsnForm: React.FC<Props> = ({ model, hasWritingAccess }) => {
  return (
    <SettingsFormContainer model={model}>
      <WallboxSettingsFormGridContainer>
        <WallboxSettingsFormGridItem>
          <CommonFieldSetEdsn model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>

        <WallboxSettingsFormGridItem>
          <HysteresisFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>
      </WallboxSettingsFormGridContainer>
    </SettingsFormContainer>
  )
}

export default WallboxSettingsEdsnForm
